import React,{useEffect, useState} from 'react'
import useStyles from './styles'
import { Grid, AppBar, TextField, Button, Typography, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox } from '@material-ui/core';
import Posts from '../Posts/Posts';
import { useDispatch, useSelector} from 'react-redux';
import { getPosts, getPostsBySearch } from '../../actions/posts';
import {  useHistory, useLocation } from 'react-router-dom';
import Slider from '@material-ui/core/Slider';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';


import Pagination from '../Pagination';



function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  function valuetext(value) {
    return `${value}`;
  }
const Home = ({ setCurrentId , currentId }) => {
    const [category,setCategory] = useState('');
    const [value,setValue] = useState([0,30000]);
    const [search, setSearch] = useState('');
    const [open, setOpen] = useState(false);
    const [checked, setChecked] = useState(false);
    const query = useQuery();
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    let filter='';
    

    const page = query.get('page') || 1;
    const loggedUser = JSON.parse(localStorage.getItem('profile'));
    
    const searchQuery = query.get('searchQuery');

    const categoryFilter = useSelector((state) => category ? state.posts.posts?.filter((e) => e.category === category) : state.posts.posts) //filtering all posts that match the category selected
    const priceFilter = useSelector((state)=> value? state.posts.posts?.filter((e) => e.price >= value[0] && e.price<= value[1]) : null)  // filtering all posts that match the price selected
    const userFilter = useSelector((state) => checked ? state.posts.posts?.filter((e) => e?.creator === loggedUser?.result?._id) : state.posts.posts)
    
    
    //Final filter
    const allPosts = useSelector((state) => state.posts.posts)
    
     
    if(allPosts && priceFilter && categoryFilter && userFilter){
      filter = allPosts.filter((e) => priceFilter.includes(e) && categoryFilter?.includes(e) && userFilter?.includes(e));
      console.log(filter)
    }
    
  
    

    useEffect(() => {
      if (query.get('page')) {
      dispatch(getPosts(page));}
      // eslint-disable-next-line
      }, [currentId, dispatch, page]
    );
    

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
          searchPost();
        }
    };

    const searchPost = () => {
        if (search.trim()) {
          dispatch(getPostsBySearch(search));
          history.push(`/posts/search?searchQuery=${search}`);
        } else {
          history.push('/');
        }
      };


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      setValue(value)
    }

    const handleCheckBox = (e) => {
      setChecked(e.target.checked);

    };
    
    

    return (
        <div>
            <div className={classes.root}>
                <section className={classes.filter}>
                <Grid item>
                    <AppBar className={classes.appBarSearch} position="static" color="inherit">
                        <TextField className={classes.search} onKeyDown={handleKeyPress} name="search" variant="outlined" label="Search Items" fullWidth value={search} onChange={(e) => setSearch(e.target.value)} />
                        <Button onClick={searchPost} className={classes.searchButton} variant="contained" color="primary">Search</Button>
                    </AppBar>
                </Grid>
                </section>
                <section className={classes.price}>
                    <Typography variant="h6">Price</Typography>
                    {!searchQuery &&
                    <>
                    <ArrowDropDownIcon onClick={handleClickOpen} style={{cursor:'pointer'}}/>
                    <Dialog   open={open} onClose={handleClose}>
                      <form onSubmit={handleSubmit}> 
                      <DialogTitle style={{textAlign:'center'}}>Price range</DialogTitle>
                      <DialogContent>
                        <Slider
                        value={value}
                        onChange={handleChange}
                        valueLabelDisplay="on"
                        aria-labelledby="range-slider"
                        getAriaValueText={valuetext}
                        className={classes.dialog}
                        max={30000}
                        />
                     </DialogContent>
                     <DialogActions>
                      <Button onClick={handleClose} color="primary" >
                        Cancel
                      </Button>
                      <Button onClick={handleClose} color="primary" type="submit">
                        Ok
                      </Button>
                    </DialogActions>
                      </form>
                    </Dialog>
                    </>
                    }
                </section>
                <section className={classes.city}>
                    <Typography variant="h6">City</Typography>
                </section>
                <section className={classes.category}>
                    <Typography variant="h6">Category</Typography>
                    {!searchQuery &&
                    <TextField select fullWidth value={category} onChange={(e) => setCategory(e.target.value)} className={classes.category2}>   
                        <MenuItem value={''}>None</MenuItem>
                        <MenuItem value={"Clothing"}>Clothing</MenuItem>
                        <MenuItem value={"Tools"}>Tools</MenuItem>
                        <MenuItem value={"Sports"}>Sports</MenuItem>
                        <MenuItem value={"Accessories"}>Accessories</MenuItem>
                        <MenuItem value={"Furniture"}>Furniture</MenuItem>
                        <MenuItem value={"Pets"}>Pets</MenuItem>
                        <MenuItem value={"Games"}>Games</MenuItem>
                        <MenuItem value={"Books"}>Books</MenuItem>
                        <MenuItem value={"Technology"}>Technology</MenuItem>
                    </TextField>
                    }
                </section>
                {loggedUser &&
                <section className={classes.checkbox}>
                    <Checkbox
                      onChange={handleCheckBox}
                      checked={checked}
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                </section>
                }
            </div>
            <Posts setCurrentId={setCurrentId} filter={filter}/>
            {!searchQuery && (
              <div className={classes.pagination}>
                <Pagination page={page} />
              </div>
            )}
        </div>    
    )
}

export default Home

   